// Helper to format a currency amount with the correct currency
export const appendCurrency = (amount, currency) =>
  `${currency || ''}$${amount || amount === 0 ? amount.toString() : ''}`;
